<template>
  <v-dialog
    v-model="dialog"
    :persistent="loading"
    max-width="926"
    width="470"
    @input="setData($event)">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="isUpdate"
        color="primary"
        :height="40"
        :ripple="false"
        elevation="0"
        v-bind="attrs"
        icon
        v-on="on">
        <v-icon
          size="22"
          class="mt-1">
          mdi-border-color
        </v-icon>
      </v-btn>
      <v-btn
        v-else
        height="40"
        color="primary"
        elevation="0"
        :ripple="false"
        v-bind="attrs"
        rounded
        v-on="on">
        <v-icon class="mr-1">
          mdi-plus-circle
        </v-icon>
        เพิ่มแบรนด์
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <div class="primary--text title">
          {{ isUpdate ? 'แก้ไขแบรนด์' : 'เพิ่มแบรนด์' }}
        </div>
        <v-spacer />
        <v-btn
          color="#A9A9A9"
          x-small
          icon
          @click="closeDialogs()">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          class="mt-4"
          lazy-validation
          @submit.prevent="onSubmit($event)">
          <label
            for="name"
            class="d-block mb-2">ชื่อแบรนด์</label>
          <v-text-field
            id="name"
            v-model.trim="name"
            :rules="nameRules"
            placeholder="ชื่อแบรนด์"
            background-color="#ffffff"
            autocomplete="off"
            hide-details
            autofocus
            outlined
            dense />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="loading"
          color="primary"
          rounded
          text
          @click="closeDialogs()">
          ยกเลิก
        </v-btn>
        <v-btn
          :ripple="false"
          :loading="loading"
          :disabled="loading"
          color="primary"
          depressed
          rounded
          @click="onSubmit()">
          ยืนยัน
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { CREATE_PRODUCT_BRAND, UPDATE_PRODUCT_BRAND } from '@/resources/graphql'

export default {
  props: {
    brandName: {
      type: String,
      default: ''
    },
    brandId: {
      type: String,
      default: ''
    },
    isUpdate: {
      type: Boolean,
      require: true
    }
  },
  data () {
    return {
      dialog: false,
      valid: false,
      name: '',
      loading: false,
      nameRules: [
        (v) => (!!v && !!v.trim()) || this.$t('app.validate.required')
      ]
    }
  },
  methods: {
    setData (val) {
      if (this.isUpdate && val) {
        this.name = this.brandName
      }
    },
    async onSubmit () {
      this.loading = true
      const vaild = await this.$refs.form.validate()
      if (vaild) {
        if (this.isUpdate) {
          await this.updateBrand()
        } else {
          await this.createBrand()
          this.$emit('onRefetch')
        }
        this.closeDialogs()
      }
      this.loading = false
    },
    createBrand () {
      return this.$apollo.mutate({
        mutation: CREATE_PRODUCT_BRAND,
        variables: {
          input: {
            name: this.name
          }
        }
      })
    },
    updateBrand () {
      return this.$apollo.mutate({
        mutation: UPDATE_PRODUCT_BRAND,
        variables: {
          input: {
            id: this.brandId,
            name: this.name
          }
        }
      })
    },
    closeDialogs () {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.name = ''
      this.loading = false
      this.dialog = false
    }
  }
}
</script>
